import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function GoogleIconField(props) {
    return (
        <FormikInput
            name={'icon'}
            label={'shippingMethods.form.field.icon.label'}
            placeholder={'shippingMethods.form.field.icon.placeholder'}
        />
    );
}

export default GoogleIconField;
